import { createUseQuery } from 'api/common/createUseQuery'
import { fetchToolsAndSupport } from 'api/fetchers/fetchToolsAndSupport'

export const useFetchToolsAndSupport = createUseQuery({
  queryKey: 'clusters',
  fetcher: fetchToolsAndSupport,
  selector: response => response?.data,
})
